import React from "react";

// Mandatory, not pre-selected consent checkbox used in registration forms.
// Links open the legal pages in a new tab so the form state is preserved.
export default function LegalConsentCheckbox({ checked, onChange, testId = "legal-consent" }) {
  return (
    <label className="flex items-start gap-2.5 cursor-pointer select-none" data-testid={`${testId}-label`}>
      <input
        type="checkbox"
        data-testid={testId}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 shrink-0 rounded border-slate-300 text-[#E63946] accent-[#E63946] focus:ring-[#E63946]/30"
      />
      <span className="text-[13px] leading-snug text-slate-600">
        Ho letto e accetto i{" "}
        <a
          href="/legal/termini"
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testId}-terms-link`}
          onClick={(e) => e.stopPropagation()}
          className="font-bold text-[#E63946] underline underline-offset-2"
        >
          Termini e Condizioni
        </a>{" "}
        del servizio e la{" "}
        <a
          href="/legal/privacy"
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testId}-privacy-link`}
          onClick={(e) => e.stopPropagation()}
          className="font-bold text-[#E63946] underline underline-offset-2"
        >
          Privacy Policy
        </a>
        .
      </span>
    </label>
  );
}
